<template>
  <div
    class="sentry"
  >
    <div v-if="loading">
      <slot name="intermediate">
        <div
          class="sentry__loading"
          v-loading="loading"
        ></div>
      </slot>
    </div>
    <div v-else>
      <slot
        v-if="allowed"
        name="allowed"
      />
      <slot
        v-else
        name="disallowed"
      >Forbidden Access</slot>
    </div>
  </div>
</template>

<script>
import LinkValidator from '@/libs/LinkValidator';

/**
 * Page sentry control the visibility of the protected page.
 *
 * [Events]
 * - allowed {result}   | Emitted after a successful validation
 * - disallowed {error} | Emitted after a errorneous validation
 *
 * [Slots]
 * - intermediate       | Optional. This slot will be displayed when the validation is still taking place
 * - allowed            | Content in this slot will be displayed upon a successful validation
 * - disallowed         | Optional. Content in this slot will be displayed upon a successful validation
 */
export default {
  data() {
    return {
      loading: true,
      allowed: false,
    };
  },
  mounted() {
    // Check if link is valid
    this.validateLink()
      .then((result) => {
        this.allowed = true;
        this.$emit('allowed', result);
      })
      .catch((error) => {
        this.allowed = false;
        this.$emit('disallowed', error);
      })
      .then(() => {
        this.loading = false;
      });
  },
  methods: {
    validateLink() {
      return LinkValidator.validate();
    },
  },
};
</script>

<style lang="scss">
.sentry__loading {
  min-height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/pages/Sentry.vue